import React from 'react';
import { Modal, Button } from 'semantic-ui-react';

const Dialog = props => {
    return (
            <Modal
                style={props.style}
                className={'mini-modal'}
                size={'small'}
                open={props.open}
            >
                <Modal.Header data-testid={props.titleTestId}>{props.title}</Modal.Header>
                <Modal.Content>
                    {props.children}
                </Modal.Content>
                <Modal.Actions>
                    <Button data-testid="dialog-button-cancel" negative onClick={props.onCancel}>
                        Cancel
                    </Button>
                    <Button data-testid="dialog-button-confirm" primary loading={props.loading} onClick={props.onConfirm}>
                        {props.confirmText}
                    </Button>
                </Modal.Actions>
            </Modal>
    );
}
export default Dialog;